import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_CLIENTS, SET_CURRENT_PAGE, SET_SEARCH_TERM } from 'src/redux/clientsReducer'
import { RootReducer } from 'src/redux/rootReducer'
import SearchInput from './SearchInput'

const ClientSearchInput = (): JSX.Element => {
  const dispatch = useDispatch()
  const searchTerm = useSelector((state: RootReducer) => state.clientsReducer.searchTerm)
  const currentPage = useSelector((state: RootReducer) => state.clientsReducer.currentPage)

  const handleChange = (value: string): void => {
    dispatch(SET_SEARCH_TERM(value))
    if (currentPage !== 1) {
      dispatch(SET_CURRENT_PAGE(1))
      return
    }
    dispatch(FETCH_CLIENTS())
  }

  return <SearchInput value={searchTerm} onChange={handleChange} />
}

export default ClientSearchInput
